import { jsx as l } from "react/jsx-runtime";
const e = (c) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12.527 10.319c.22-.456.368-.935.44-1.43h.018a1.502 1.502 0 0 0 1.515-1.49l-1.54-.01a4.946 4.946 0 0 0-.94-2.212l.072-.066a1.495 1.495 0 0 0 .076-2.119l-1.222 1.133a4.979 4.979 0 0 0-2.26-.899l.002-.217A1.502 1.502 0 0 0 7.193 1.5L7.18 3.252a4.987 4.987 0 0 0-2.07.863l-.083-.089A1.51 1.51 0 0 0 2.9 3.953l1.133 1.209a4.946 4.946 0 0 0-.95 2.218h-.069A1.502 1.502 0 0 0 1.5 8.87l1.575.01A4.95 4.95 0 0 0 4.1 11.25h-.001c-.395 0-.554-.122-.842-.344-.36-.277-.853-.655-1.757-.655v1.5c.394 0 .553.122.842.344.36.277.852.655 1.757.655.904 0 1.396-.378 1.756-.654l.002-.001c.288-.222.448-.345.842-.345.395 0 .554.123.843.345.36.277.852.655 1.757.655.904 0 1.396-.378 1.756-.654l.001-.001h.001c.288-.222.447-.345.842-.345.395 0 .554.123.842.344l.001.001c.36.277.852.655 1.757.655v-1.5c-.394 0-.553-.122-.841-.343l-.002-.001c-.265-.204-.605-.465-1.129-.586Zm-2.122.387c.315-.293.57-.637.759-1.021.232-.476.351-.989.351-1.524a3.491 3.491 0 0 0-3.494-3.48 3.491 3.491 0 0 0-3.494 3.48 3.46 3.46 0 0 0 .949 2.385A2.492 2.492 0 0 1 6.7 10.25c.904 0 1.397.378 1.756.655.29.222.448.345.843.345.395 0 .554-.123.842-.344l.001-.001c.08-.062.168-.13.266-.197l-.003-.003ZM6.678 6.005l1.85-.516v1.354l.916-.245-1.227 3.89-.62-1.822-.92.246V6.005Z",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  e as HydroPower
};
